"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensQueryWrapper = void 0;
var components_1 = require("@apollo/client/react/components");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var queries_1 = require("../../../gen-src/queries");
var renderQueryResult_1 = require("../renderQueryResult");
var ErrorMessageWidgets_1 = require("../widgets/ErrorMessageWidgets");
var LensQueryWrapper = function (props) {
    var renderLensData = function (data) {
        var lens = data.lenses ? data.lenses[0] : null;
        return lens ? props.children(lens) : react_1.default.createElement(data_catalog_shared_1.CenteredMessage, { message: Localize_1.Messages.ErrorItemNotFound() });
    };
    return react_1.default.createElement(components_1.Query, { query: queries_1.LensDocument, variables: { vizportalUrlId: props.vizportalUrlId } }, function (result) { return react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
            renderLoading: data_catalog_shared_1.CenteredFadeInSpinner,
            renderData: renderLensData,
            renderNoData: ErrorMessageWidgets_1.renderNoData,
            renderDataWithError: (0, ErrorMessageWidgets_1.createRenderDataWithErrorFunction)(renderLensData),
            renderError: ErrorMessageWidgets_1.renderError,
        } }); });
};
exports.LensQueryWrapper = LensQueryWrapper;
//# sourceMappingURL=LensQueryWrapper.js.map